import {
  GET_PACKAGE_DATA,
  LOAD_MORE_PACKAGE_DATA,
  SEARCH_PACKAGE_DATA,
} from "../types";
import axios from "axios";
import { firebase } from "../../../firebase/initFirebase";
import moment from "moment";
import { store } from "../../store";
import { message } from "antd";

export const getPackageData = (props) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var useremail = reduxState.auth.user.email;
    var userLocation = reduxState.auth.user.branch;
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("packages");
    // console.log(props)

    dataRef = dataRef.orderBy("created_at", "desc");
    if (props.packageStatus) {
      dataRef = dataRef.where("status", "==", props.packageStatus);
    }
    if (
      userRole !== "admin" &&
      userRole !== "warehouse" &&
      userRole !== "manager"
    ) {
      dataRef = dataRef.where("destination", "==", userLocation);
    }

    // if(props.searchText){
    //   dataRef = dataRef.orderBy('name').startAt(props.searchText).endAt(props.searchText + '\uf8ff')
    // }
    // if(props.filters){
    //   if(props.filters.length > 0){
    //     props.filters.map(item=>{
    //       console.log(item)
    //       dataRef = dataRef.orderBy(item.dataIndex).startAt(item.value).endAt(item.value + '\uf8ff')
    //     })
    //   }
    // }

    dataRef = dataRef.limit(40);

    var documentSnapshots = await dataRef.get();
    var docs = documentSnapshots.docs;
    var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];
    var dataArray = [];

    await Promise.all(
      docs.map(async (packageItem) => {
        var newOrder = {
          key: packageItem.id,
          id: packageItem.id,
          ...packageItem.data(),
        };
        var dataRefItems = Firestore.collection("packages")
          .doc(packageItem.id)
          .collection("items");
        var documentSnapshots2 = await dataRefItems.get();
        var docs2 = documentSnapshots2.docs;
        var newItems = [];

        await Promise.all(
          docs2.map(async (item) => {
            var bago = {
              key: item.id,
              id: item.id,
              ...item.data(),
            };
            if (bago.product) {
              var itemref = Firestore.collection("products").doc(bago.product);
              var newd = await itemref.get();

              if (newd.data()) {
                var data3 = newd.data();
                var localavailable = 0;
                var destinationavailable = 0;

                if (data3[`${userLocation}_count`]) {
                  localavailable = data3[`${userLocation}_count`];
                }
                if (data3[`${newOrder.destination}_count`]) {
                  destinationavailable = data3[`${newOrder.destination}_count`];
                }
                bago["destination_available"] = destinationavailable;
                bago["location_available"] = localavailable;
                bago["regionalization"] = data3.regionalization;
              }
            }
            newItems.push(bago);
          })
        );
        newOrder["items"] = newItems;
        dataArray.push(newOrder);
      })
    );
    dispatch({
      type: GET_PACKAGE_DATA,
      payload: {
        dataArray: dataArray,
        lastVisible: lastVisible,
        currentProps: props,
      },
    });
  };
};

export const loadMorePackageData = () => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var useremail = reduxState.auth.user.email;
    var currentLastItem = reduxState.packages.lastVisible;
    var userLocation = reduxState.auth.user.branch;
    var currentProps = reduxState.packages.currentProps;
    var Firestore = firebase.firestore();

    var dataRef = Firestore.collection(currentProps.apiurl);

    dataRef = dataRef.orderBy("created_at", "desc");

    if (currentProps.packageStatus) {
      dataRef = dataRef.where("status", "==", currentProps.packageStatus);
    }

    if (
      userRole !== "admin" &&
      userRole !== "warehouse" &&
      userRole !== "manager"
    ) {
      dataRef = dataRef.where("destination", "==", userLocation);
    }

    if (currentLastItem) {
      dataRef = dataRef.startAfter(currentLastItem);

      if (currentProps.searchText) {
        dataRef = dataRef
          .where("name", ">=", currentProps.searchText)
          .where("name", "<=", currentProps.searchText + "\uf8ff");
      }

      dataRef = dataRef.limit(100);

      dataRef.get();
      var documentSnapshots = await dataRef.get();
      var docs = documentSnapshots.docs;
      if (docs) {
        var lastVisible =
          documentSnapshots.docs[documentSnapshots.docs.length - 1];
        var dataArray = [];
        await Promise.all(
          docs.map(async (packageItem) => {
            var newOrder = {
              key: packageItem.id,
              id: packageItem.id,
              ...packageItem.data(),
            };
            var dataRefItems = Firestore.collection("packages")
              .doc(packageItem.id)
              .collection("items");
            var documentSnapshots2 = await dataRefItems.get();
            var docs2 = documentSnapshots2.docs;
            var newItems = [];
            await Promise.all(
              docs2.map(async (item) => {
                var bago = {
                  key: item.id,
                  id: item.id,
                  ...item.data(),
                };
                if (bago.product) {
                  var itemref = Firestore.collection("products").doc(
                    bago.product
                  );
                  var newd = await itemref.get();
                  if (newd.data()) {
                    var data3 = newd.data();
                    var localavailable = 0;
                    var destinationavailable = 0;

                    if (data3[`${userLocation}_count`]) {
                      localavailable = data3[`${userLocation}_count`];
                    }
                    if (data3[`${packageItem.destination}_count`]) {
                      destinationavailable =
                        data3[`${packageItem.destination}_count`];
                    }
                    bago["destination_available"] = destinationavailable;
                    bago["location_available"] = localavailable;
                    bago["regionalization"] = data3.regionalization;
                  }
                }
                newItems.push(bago);
              })
            );
            newOrder["items"] = newItems;

            dataArray.push(newOrder);
          })
        );
        if (lastVisible && currentLastItem !== lastVisible) {
          dispatch({
            type: LOAD_MORE_PACKAGE_DATA,
            payload: { dataArray: dataArray, lastVisible: lastVisible },
          });
        } else {
          message.error("No More Orders To Load");
        }
      } else {
        message.error("No More Orders To Load");
      }
    }
  };
};

export const searchPackageData = (filter, data) => {
  return (dispatch) => {
    dispatch({
      type: SEARCH_PACKAGE_DATA,
      filter: filter,
      data: data,
    });
  };
};

export const retrievePackage = (ID) => {
  return async (dispatch) => {
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("packages").doc(ID);
    var ItemsRef = Firestore.collection("packages").doc(ID).collection("items");
    var documentSnapshots = await dataRef.get();
    var mainpackage = documentSnapshots.data();
    var documentSnapshots2 = await ItemsRef.get();
    var itemdocs = documentSnapshots2.docs;
    var newItems = [];

    await Promise.all(
      itemdocs.map(async (itemx) => {
        var newOrder = {
          key: itemx.id,
          id: itemx.id,
          ...itemx.data(),
        };
        var productRef = Firestore.collection("products").doc(newOrder.product);
        var documentSnapshots3 = await productRef.get();
        var prodData = documentSnapshots3.data();
        newOrder["source"] = prodData;
        newItems.push(newOrder);
      })
    );
    mainpackage["items"] = newItems;
    mainpackage["id"] = documentSnapshots.id;

    return mainpackage;
  };
};

export const readyShip = (currentPack) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var userLocation = reduxState.auth.user.branch;
    var userLocationName = reduxState.auth.user.branch_name;

    var packageRef = Firestore.collection("packages").doc(currentPack.id);
    var ItemsRef = Firestore.collection("packages")
      .doc(currentPack.id)
      .collection("items");

    var prodRef = Firestore.collection("products");
    var inventoryRef = Firestore.collection("inventory");

    var exchangerateRef = Firestore.collection("config").doc(
      "weightedexchangerate"
    );
    var exchangerateSnapshot = await exchangerateRef.get();

    var exchangeitem = exchangerateSnapshot.data().value;

    var dest = currentPack.destination;

    var packdata = {
      status: "toShip",
      packed_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      packed_by: userID,
      packed_name: userName,
      exchange_rate: exchangeitem,
    };
    console.log(packdata);
    var step1 = await packageRef.update(packdata, { merge: true });
    console.log("package toShip", step1);
    Promise.all(
      currentPack.items.map(async (indx) => {
        var newPackgeItem = {
          cost_peso: indx.source.cost_peso ? indx.source.cost_peso : 0,
          cost_rmb: indx.source.cost_rmb ? indx.source.cost_rmb : 0,
          cost_rmb: indx.source.cost_rmb ? indx.source.cost_rmb : 0,
          category: indx.source.category,
          category_name: indx.source.category_name,
          regionalization: indx.source.regionalization,
          cost_rmb_adjusted: indx.source.cost_rmb
            ? parseFloat(indx.source.cost_rmb) * 1.05
            : 0,
        };

        var prodData = {
          updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
          updated_by: userID,
          updated_name: userName,
        };

        var inventoryID = `${userLocation}_${indx.product}`;
        var InventoryData = {
          updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
          updated_by: userID,
          updated_name: userName,
          reason: "packed",
          product: indx.product,
          product_name: indx.product_name,
          location: userLocation,
          location_name: userLocationName,
        };

        var inventoryLogForm = {
          created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
          reason: "packed",
          created_by: userID,
          created_name: userName,
        };
        // if(userLocation == dest){

        // }else{
        if (indx.source[`${userLocation}_count`]) {
          prodData[`${userLocation}_count`] =
            parseFloat(indx.source[`${userLocation}_count`]) -
            parseFloat(indx.quantity);
          InventoryData["quantity"] =
            parseFloat(indx.source[`${userLocation}_count`]) -
            parseFloat(indx.quantity);
          inventoryLogForm["quantity"] =
            parseFloat(indx.source[`${userLocation}_count`]) -
            parseFloat(indx.quantity);
        } else {
          prodData[`${userLocation}_count`] = 0 - parseFloat(indx.quantity);
          InventoryData["quantity"] = 0 - parseFloat(indx.quantity);
          inventoryLogForm["quantity"] = 0 - parseFloat(indx.quantity);
        }
        // }

        console.log(newPackgeItem, prodData, InventoryData, inventoryLogForm);

        var packageitemchange = await ItemsRef.doc(indx.id).set(newPackgeItem, {
          merge: true,
        });
        var productChange = await prodRef
          .doc(indx.product)
          .set(prodData, { merge: true });
        var inventoryChange = await inventoryRef
          .doc(inventoryID)
          .set(InventoryData, { merge: true });
        var inventoryLogMake = await inventoryRef
          .doc(inventoryID)
          .collection("inventory_log")
          .doc()
          .set(inventoryLogForm);
      })
    );
    return "oks";
  };
};

export const completePackage = (currentPack) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var userLocation = reduxState.auth.user.branch;
    var userLocationName = reduxState.auth.user.branch_name;
    var dest = currentPack.destination;
    var destName = currentPack.destination_name;

    var packageRef = Firestore.collection("packages").doc(currentPack.id);
    var ItemsRef = Firestore.collection("packages")
      .doc(currentPack.id)
      .collection("items");

    var prodRef = Firestore.collection("products");
    var inventoryRef = Firestore.collection("inventory");

    var packdata = {
      status: "completed",
      received_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      received_by: userID,
      received_name: userName,
    };
    if (userLocation == dest) {
      var exchangerateRef = Firestore.collection("config").doc(
        "weightedexchangerate"
      );
      var exchangerateSnapshot = await exchangerateRef.get();

      var exchangeitem = exchangerateSnapshot.data().value;
      packdata["exchange_rate"] = exchangeitem;
    }

    var step1 = await packageRef.update(packdata, { merge: true });
    var step2 = await Promise.all(
      currentPack.items.map(async (indx) => {
        var newPackgeItem = {
          cost_peso: indx.source.cost_peso ? indx.source.cost_peso : 0,
          cost_rmb: indx.source.cost_rmb ? indx.source.cost_rmb : 0,
          cost_rmb: indx.source.cost_rmb ? indx.source.cost_rmb : 0,
          regionalization: indx.source.regionalization,
          category: indx.source.category,
          category_name: indx.source.category_name,
          cost_rmb_adjusted: indx.source.cost_rmb
            ? parseFloat(indx.source.cost_rmb) * 1.05
            : 0,
        };

        var prodData = {
          updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
          updated_by: userID,
          updated_name: userName,
        };

        var inventoryID = `${dest}_${indx.product}`;
        var InventoryData = {
          updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
          updated_by: userID,
          updated_name: userName,
          reason: "received",
          product: indx.product,
          product_name: indx.product_name,
          location: dest,
          location_name: destName,
        };

        var inventoryLogForm = {
          created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
          reason: "received",
          created_by: userID,
          created_name: userName,
        };

        if (indx.source[`${dest}_count`]) {
          prodData[`${dest}_count`] =
            parseFloat(indx.source[`${dest}_count`]) +
            parseFloat(indx.quantity);
          InventoryData["quantity"] =
            parseFloat(indx.source[`${dest}_count`]) +
            parseFloat(indx.quantity);
          inventoryLogForm["quantity"] =
            parseFloat(indx.source[`${dest}_count`]) +
            parseFloat(indx.quantity);
        } else {
          prodData[`${dest}_count`] = parseFloat(indx.quantity);
          InventoryData["quantity"] = parseFloat(indx.quantity);
          inventoryLogForm["quantity"] = parseFloat(indx.quantity);
        }

        if (userLocation == dest) {
          var packageitemchange = await ItemsRef.doc(indx.id).set(
            newPackgeItem,
            { merge: true }
          );
        }
        if (dest !== "h6GwRVeqvvU8qOsp90Np") {
          var productChange = await prodRef
            .doc(indx.product)
            .set(prodData, { merge: true });
          var inventoryChange = await inventoryRef
            .doc(inventoryID)
            .set(InventoryData, { merge: true });
          var inventoryLogMake = await inventoryRef
            .doc(inventoryID)
            .collection("inventory_log")
            .doc()
            .set(inventoryLogForm);
        }
      })
    );
    return "oks";
  };
};

export const completeDirectPackage = (currentPack) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var userLocation = reduxState.auth.user.branch;
    var userLocationName = reduxState.auth.user.branch_name;
    var dest = currentPack.destination;
    var destName = currentPack.destination_name;

    var packageRef = Firestore.collection("packages").doc(currentPack.id);
    var ItemsRef = Firestore.collection("packages")
      .doc(currentPack.id)
      .collection("items");

    var prodRef = Firestore.collection("products");
    var inventoryRef = Firestore.collection("inventory");

    var packdata = {
      status: "completed",
      received_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      received_by: userID,
      received_name: userName,
    };
    if (userLocation == dest) {
      var exchangerateRef = Firestore.collection("config").doc(
        "weightedexchangerate"
      );
      var exchangerateSnapshot = await exchangerateRef.get();

      var exchangeitem = exchangerateSnapshot.data().value;
      packdata["exchange_rate"] = exchangeitem;
    }

    var step1 = await packageRef.update(packdata, { merge: true });
    var step2 = await Promise.all(
      currentPack.items.map(async (indx) => {
        var newPackgeItem = {
          cost_peso: indx.source.cost_peso ? indx.source.cost_peso : 0,
          cost_rmb: indx.source.cost_rmb ? indx.source.cost_rmb : 0,
          cost_rmb: indx.source.cost_rmb ? indx.source.cost_rmb : 0,
          regionalization: indx.source.regionalization,
          category: indx.source.category,
          category_name: indx.source.category_name,
          cost_rmb_adjusted: indx.source.cost_rmb
            ? parseFloat(indx.source.cost_rmb) * 1.05
            : 0,
          quantity: indx.received_quantity,
          quantity_discrepancy:
            parseFloat(indx.ordered_quantity) -
            parseFloat(indx.received_quantity),
        };

        var prodData = {
          updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
          updated_by: userID,
          updated_name: userName,
        };

        var inventoryID = `${dest}_${indx.product}`;
        var InventoryData = {
          updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
          updated_by: userID,
          updated_name: userName,
          reason: "received",
          product: indx.product,
          product_name: indx.product_name,
          location: dest,
          location_name: destName,
        };

        var inventoryLogForm = {
          created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
          reason: "received",
          created_by: userID,
          created_name: userName,
        };

        if (indx.source[`${dest}_count`]) {
          prodData[`${dest}_count`] =
            parseFloat(indx.source[`${dest}_count`]) +
            parseFloat(indx.received_quantity);
          InventoryData["quantity"] =
            parseFloat(indx.source[`${dest}_count`]) +
            parseFloat(indx.received_quantity);
          inventoryLogForm["quantity"] =
            parseFloat(indx.source[`${dest}_count`]) +
            parseFloat(indx.received_quantity);
        } else {
          prodData[`${dest}_count`] = parseFloat(indx.received_quantity);
          InventoryData["quantity"] = parseFloat(indx.received_quantity);
          inventoryLogForm["quantity"] = parseFloat(indx.received_quantity);
        }

        if (userLocation == dest) {
          var packageitemchange = await ItemsRef.doc(indx.id).set(
            newPackgeItem,
            { merge: true }
          );
        }
        if (dest !== "h6GwRVeqvvU8qOsp90Np") {
          var productChange = await prodRef
            .doc(indx.product)
            .set(prodData, { merge: true });
          var inventoryChange = await inventoryRef
            .doc(inventoryID)
            .set(InventoryData, { merge: true });
          var inventoryLogMake = await inventoryRef
            .doc(inventoryID)
            .collection("inventory_log")
            .doc()
            .set(inventoryLogForm);
        }
      })
    );
    return "oks";
  };
};

export const completeDirectPackageManual = (currentPack) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var userLocation = reduxState.auth.user.branch;
    var userLocationName = reduxState.auth.user.branch_name;
    var dest = currentPack.destination;
    var destName = currentPack.destination_name;

    var packageRef = Firestore.collection("packages").doc(currentPack.id);
    var ItemsRef = Firestore.collection("packages")
      .doc(currentPack.id)
      .collection("items");

    var prodRef = Firestore.collection("products");
    var inventoryRef = Firestore.collection("inventory");

    var packdata = {
      status: "completed",
      // received_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      // received_by: userID,
      // received_name: userName,
    };
    if (userLocation == dest) {
      var exchangerateRef = Firestore.collection("config").doc(
        "weightedexchangerate"
      );
      var exchangerateSnapshot = await exchangerateRef.get();

      var exchangeitem = exchangerateSnapshot.data().value;
      packdata["exchange_rate"] = exchangeitem;
    }

    const enrichedItems = await Promise.all(
      currentPack.items.map(async (item) => {
        const docRef = Firestore.collection("products").doc(item.product);
        try {
          const docSnap = await docRef.get();
          if (!docSnap.exists) {
            console.log("No such document!", item.product);
            return item; // just pass through the original item
          }
          const data = docSnap.data();

          var inventoryID = `${dest}_${item.product}`;
          var inventoryFeild = `${dest}_count`;

          var newItem = {
            ...item,
            source: data,
            // Option A: use the current time
            date: new Date(),
            // Option B: use the Firestore createTime (uncomment to use)
            // date: docSnap.createTime.toDate(),
          };
          if (!data[inventoryFeild]) {
            console.log(inventoryID, data[inventoryFeild]);

            const inventoryDocRef = inventoryRef.doc(inventoryID);
            const inventoryDocSnap = await inventoryDocRef.get();
            if (!inventoryDocSnap.exists) {
              console.log("No such document!", inventoryID);
              return item; // just pass through the original item
            }
            const inventoryDocData = inventoryDocSnap.data();

            console.log("inventoryDocData", inventoryID, inventoryDocData);
          }
          return newItem;
        } catch (err) {
          console.error("Error fetching document:", err);
          return item;
        }
      })
    );

    // replace your items array
    currentPack.items = enrichedItems;

    // console.log("currentPack.items", currentPack.items);

    var step1 = await packageRef.update(packdata, { merge: true });
    var step2 = await Promise.all(
      currentPack.items.map(async (indx) => {
        console.log("indx.source", indx.source);

        var prodData = {
          updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
          // updated_by: userID,
          // updated_name: userName,
        };

        var inventoryID = `${dest}_${indx.product}`;
        var InventoryData = {
          updated_at: currentPack.received_at,
          updated_by: currentPack.received_by,
          updated_name: currentPack.received_name,
          reason: "correction [OrOoH69jULSE25fSvaK9]",
          product: indx.product,
          product_name: indx.product_name,
          location: dest,
          location_name: destName,
        };

        var inventoryLogForm = {
          created_at: currentPack.received_at,
          reason: "correction [OrOoH69jULSE25fSvaK9]",
          created_by: currentPack.received_by,
          created_name: moment().format("YYYY-MM-DD HH:mm:ss"),
        };

        if (indx.source[`${dest}_count`]) {
          prodData[`${dest}_count`] =
            parseFloat(indx.source[`${dest}_count`]) +
            parseFloat(indx.quantity);
          InventoryData["quantity"] =
            parseFloat(indx.source[`${dest}_count`]) +
            parseFloat(indx.quantity);
          inventoryLogForm["quantity"] =
            parseFloat(indx.source[`${dest}_count`]) +
            parseFloat(indx.quantity);
        } else {
          prodData[`${dest}_count`] = parseFloat(indx.quantity);
          InventoryData["quantity"] = parseFloat(indx.quantity);
          inventoryLogForm["quantity"] = parseFloat(indx.quantity);
        }

        // now log the details
        console.log(
          `Product ${indx.product} – ${dest}_count updated:\n` +
            `  previous1: ${indx.source[`${dest}_count`]}\n` +
            `  new1: ${indx.quantity}\n` +
            `  previous: ${parseFloat(indx.source[`${dest}_count`])}\n` +
            `  new: ${parseFloat(indx.quantity)}\n` +
            `  new total: ${inventoryLogForm["quantity"]}`
        );

        //////////////////////////////////////////////////////////
        // var inventoryLogDelete = await inventoryRef
        //   .doc(inventoryID)
        //   .collection("inventory_log")
        //   .where("created_at", "==", currentPack.received_at);

        // const snapshot = await inventoryLogDelete.get();
        // if (snapshot.empty) {
        //   console.log("No matching logs to delete");
        // } else {
        //   // 2a. Option A: delete in parallel
        //   await Promise.all(snapshot.docs.map((doc) => doc.ref.delete()));
        //   console.log(`Deleted ${snapshot.size} entries`);
        // }
        // console.log(inventoryLogDelete);
        //////////////////////////////////////////////////////////

        // if (userLocation == dest) {
        //   var packageitemchange = await ItemsRef.doc(indx.id).set(
        //     newPackgeItem,
        //     { merge: true }
        //   );
        // }
        var productChange = await prodRef
          .doc(indx.product)
          .set(prodData, { merge: true });
        var inventoryChange = await inventoryRef
          .doc(inventoryID)
          .set(InventoryData, { merge: true });
        var inventoryLogMake = await inventoryRef
          .doc(inventoryID)
          .collection("inventory_log")
          .doc()
          .set(inventoryLogForm);
      })
    );
    console.log("manual complete done");
    return "oks";
  };
};

export const addPackage = (data, apiurl) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection(apiurl);

    return dataRef.doc().set(data);
  };
};

export const editPackage = (data, apiurl, id) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var OrdersRef = Firestore.collection(apiurl);

    return OrdersRef.doc(id).update(data);
  };
};

export const setPackage = (data, id) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("packages");
    return dataRef.doc(id).set(data, { merge: true });
  };
};

export const updatePackage = (data, apiurl, id) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection(apiurl);
    return dataRef.doc(id).update(data, { merge: true });
  };
};

export const deletePackage = (apiurl, id) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var OrdersRef = Firestore.collection(apiurl);

    return OrdersRef.doc(id).delete();
  };
};

export const mergePackage = (removePackage, keepPackage) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var keepPackageItemsref = Firestore.collection("packages")
      .doc(keepPackage.id)
      .collection("items");
    var removeref = Firestore.collection("packages").doc(removePackage.id);
    var removerefitems = Firestore.collection("packages")
      .doc(removePackage.id)
      .collection("items");

    var waiting = await Promise.all(
      removePackage.items.map(async (indx) => {
        var newItem = {
          product: indx.product,
          product_name: indx.product_name,
          quantity: indx.quantity,
          unit: indx.unit,
        };
        var oldpresent = null;
        keepPackage.items.map((oldit) => {
          if (indx.product == oldit.product) {
            oldpresent = oldit.id;
            newItem["quantity"] =
              parseFloat(indx.quantity) + parseFloat(oldit.quantity);
          }
        });

        if (oldpresent) {
          var updateqty = await keepPackageItemsref
            .doc(oldpresent)
            .set(newItem);
        } else {
          var putItem = await keepPackageItemsref.doc().set(newItem);
        }
      })
    );
    var deleteold = await removeref.delete();
    return "merge done";
  };
};

export const createPackage = (destinationdata) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var userRole = reduxState.auth.user.role;

    var cartData = [];
    var cartData_Direct = [];

    var cartRef = Firestore.collection("users").doc(userID).collection("cart");
    var cartSnapshot = await cartRef.get();
    var cartdocs = cartSnapshot.docs;
    var destinationId = destinationdata.destination;

    cartdocs.map((item) => {
      var newOrder = {
        key: item.id,
        id: item.id,
        ...item.data(),
      };

      if (newOrder?.direct_ship) {
        if (newOrder?.direct_ship.includes(destinationId)) {
          cartData_Direct.push(newOrder);
        } else {
          cartData.push(newOrder);
        }
      } else {
        cartData.push(newOrder);
      }
    });
    console.log("//////////////////////");
    console.log(cartData.length);
    console.log(cartData_Direct.length);

    if (cartData.length > 0) {
      var dataRef = Firestore.collection("packages").doc();
      var presetId = dataRef.id;
      var dataItemRef = Firestore.collection("packages")
        .doc(presetId)
        .collection("items");

      var form = {
        ...destinationdata,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
        created_by: userID,
        created_name: userName,
        is_direct: false,
      };

      var step1 = await dataRef.set(form);

      var waiting = await Promise.all(
        cartData.map(async (indx) => {
          var newItem = {
            product: indx.product,
            product_name: indx.product_name,
            quantity: indx.quantity,
            unit: indx.unit,
          };
          var putItem = await dataItemRef.doc().set(newItem);
        })
      );
    }

    if (cartData_Direct.length > 0) {
      var dataRef2 = Firestore.collection("packages").doc();
      var presetId2 = dataRef2.id;
      var dataItemRef2 = Firestore.collection("packages")
        .doc(presetId2)
        .collection("items");

      var form2 = {
        ...destinationdata,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
        created_by: userID,
        created_name: userName,
        is_direct: true,
      };

      if (userRole == "admin" || userRole == "manager") {
        form2["status"] = "shipping";
      }

      var step2 = await dataRef2.set(form2);

      var waiting2 = await Promise.all(
        cartData_Direct.map(async (indx) => {
          var newItem = {
            product: indx.product,
            product_name: indx.product_name,
            quantity: indx.quantity,
            ordered_quantity: indx.quantity,
            unit: indx.unit,
          };
          var putItem = await dataItemRef2.doc().set(newItem);
        })
      );
    }

    return "hi";
  };
};

export const approvePackage = (record, id) => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("packages");
    var data = {
      approved_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      approved_by: userID,
      approved_by_name: userName,
      status: record.is_direct ? "shipping" : "toPack",
    };
    return dataRef.doc(id).update(data, { merge: true });
  };
};

export const backtoPendingPackage = (id) => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("packages");
    var data = {
      status: "pending",
    };
    return dataRef.doc(id).update(data, { merge: true });
  };
};

export const editPackageItem = (data, packID, id) => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userId = reduxState.auth.user.id;
    var Firestore = firebase.firestore();
    var packItemRef = Firestore.collection("packages")
      .doc(packID)
      .collection("items");
    return packItemRef.doc(id).set(data, { merge: true });
  };
};

export const deletePackagetItem = (packID, id) => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userId = reduxState.auth.user.id;
    var Firestore = firebase.firestore();
    var packItemRef = Firestore.collection("packages")
      .doc(packID)
      .collection("items");

    return packItemRef.doc(id).delete();
  };
};

export const deleteByPackagesItembyProductID = (packages, prodID) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userId = reduxState.auth.user.id;
    var Firestore = firebase.firestore();
    await Promise.all(
      packages.map(async (pack) => {
        var packItemRef = Firestore.collection("packages")
          .doc(pack.id)
          .collection("items");
        packItemRef = packItemRef.where("product", "==", prodID);
        var documentSnapshots = await packItemRef.get();
        var docs = documentSnapshots.docs;
        await Promise.all(
          docs.map(async (packageItem) => {
            return packItemRef.doc(packageItem.id).delete();
          })
        );
      })
    );
  };
};

export const attachSource = (consolidata) => {
  return async (dispatch) => {
    var Firestore = firebase.firestore();
    var exchangerateRef = Firestore.collection("config").doc(
      "weightedexchangerate"
    );
    var exchangerateSnapshot = await exchangerateRef.get();
    // console.log( exchangerateSnapshot.data())
    var exchangeitem = exchangerateSnapshot.data().value;

    var newItems = [];

    await Promise.all(
      consolidata.map(async (itemx) => {
        var productRef = Firestore.collection("products").doc(itemx.product);
        var documentSnapshots3 = await productRef.get();
        var prodData = documentSnapshots3.data();

        var newOrder = {
          ...prodData,
          exchangerate: exchangeitem,
          ...itemx,
        };
        newItems.push(newOrder);
      })
    );

    return newItems;
  };
};

export const fixbrockenpackages = (tofixpackages) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var Firestore = firebase.firestore();
    var exchangerateRef = Firestore.collection("config").doc(
      "weightedexchangerate"
    );
    var exchangerateSnapshot = await exchangerateRef.get();
    var exchangeitem = exchangerateSnapshot.data().value;

    for (let i = 0; i < tofixpackages.length; i++) {
      var currentPack = tofixpackages[i];

      var packageRef = Firestore.collection("packages").doc(currentPack.id);
      var ItemsRef = Firestore.collection("packages")
        .doc(currentPack.id)
        .collection("items");
      console.log(`fixing package:${currentPack.id}`);
      message.info(`fixing package:${currentPack.id}`);
      if (!currentPack.exchange_rate) {
        var packdata = {
          exchange_rate: exchangeitem,
        };
        var step1 = await packageRef.update(packdata, { merge: true });
      }

      for (let x = 0; x < currentPack.items.length; x++) {
        var indx = currentPack.items[x];
        if (
          indx.cost_peso == undefined ||
          indx.cost_rmb_adjusted == undefined ||
          indx.category == undefined
        ) {
          var productRef = Firestore.collection("products").doc(indx.product);
          var documentSnapshots3 = await productRef.get();
          var prodData = documentSnapshots3.data();
          console.log(
            `${i}/${tofixpackages.length}  ===  ${x}/${currentPack.items.length}`
          );
          if (prodData) {
            message.info(`fixing package Item:${currentPack.id} - ${indx.id}`);

            var newPackgeItem = {
              cost_peso: prodData.cost_peso ? prodData.cost_peso : 0,
              cost_rmb: prodData.cost_rmb ? prodData.cost_rmb : 0,
              cost_rmb: prodData.cost_rmb ? prodData.cost_rmb : 0,
              category: prodData.category,
              category_name: prodData.category_name,
              regionalization: prodData.regionalization,
              cost_rmb_adjusted: prodData.cost_rmb
                ? parseFloat(prodData.cost_rmb) * 1.05
                : 0,
            };

            message.success(
              `FIXED package Item:${currentPack.id} - ${indx.id}`
            );
            var packageitemchange = await ItemsRef.doc(indx.id).set(
              newPackgeItem,
              { merge: true }
            );
          } else {
            console.log(`broken product:${currentPack.id}/items/${indx.id}`);

            console.log(indx);
          }
        }
      }
    }
    return "oks";
  };
};
